import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ERC20_ABI } from '../../../blockchain/abi/typescript/Erc_20_Abi';
import { UINT_256_MAX_BN } from '../../../constants/blockchain-constants';
import { State } from '../../../reducers';
import metamaskService from '../../../services/metamask.service';
import { StakingPool } from '../../../services/staking/staking.types';
import web3Service from '../../../services/web3.service';
import { NetworkId } from '../../../types/network.types';

interface Props
  extends Pick<StakingPool, 'stakingTokenAddress' | 'stakingContractAddress' | 'networkId'> {
  walletNetworkId: NetworkId;
  networkId: NetworkId;
}

//@TODO would be good to move this all to redux with redux-thunk
export function usePreApproved({
  walletNetworkId,
  stakingTokenAddress,
  stakingContractAddress,

  networkId,
}: Props) {
  const [needsApproving, setNeedsApproving] = useState(false);
  const [isApproved, setIsApproved] = useState(false);
  const [loading, setLoading] = useState(false);

  const { walletAddress } = useSelector(({ account }: State) => ({
    walletAddress: account.address,
  }));

  /**
   * is the user in a position to be approved. This is true when the allowance
   * is less than the specified threshold
   */
  async function checkNeedsApproving() {
    setLoading(true);
    try {
      const paymentTokenContract = new (web3Service.getInstanceByNetworkId(
        walletNetworkId,
      ).eth.Contract)(ERC20_ABI, stakingTokenAddress);
      const allowance = await paymentTokenContract.methods
        .allowance(walletAddress, stakingContractAddress)
        .call();

      setNeedsApproving(parseInt(allowance) < 10000000000000000000000000000);
      setIsApproved(parseInt(allowance) > 10000000000000000000000000000);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  }

  async function approve() {
    if (needsApproving) {
      const metamaskInstance = metamaskService.getInstance();
      const paymentTokenContract = new metamaskInstance.eth.Contract(
        ERC20_ABI,
        stakingTokenAddress,
      );

      try {
        const result = await paymentTokenContract.methods
          .approve(stakingContractAddress, UINT_256_MAX_BN)
          .send({
            from: walletAddress,
          });

        if (result?.status) {
          setNeedsApproving(false);
          setIsApproved(true);
        }
      } catch (error) {
        throw error;
      }
    }
  }

  useEffect(() => {
    if (walletAddress && walletNetworkId === networkId) {
      checkNeedsApproving();
    }
  }, [walletNetworkId]);
  return {
    approve,
    isApproved,
    needsApproving,
    loading,
  };
}
